import * as requests from './commonAPI';

const Reports = {
	createReport: (report) => 
		requests.post(`/reports`, { report }),
}

export default Reports;